import { render, staticRenderFns } from "./driverChannel.vue?vue&type=template&id=fd6e30a0&scoped=true"
import script from "./driverChannel.vue?vue&type=script&lang=js"
export * from "./driverChannel.vue?vue&type=script&lang=js"
import style0 from "./driverChannel.vue?vue&type=style&index=0&id=fd6e30a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6e30a0",
  null
  
)

export default component.exports